import * as React from 'react';
export const meowSvg = React.forwardRef(function meowSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FF6631',
      d: 'M24.622 6.313c-.179.04-4.306.984-8.622 2.605a74.021 74.021 0 0 0-8.622-2.605L6 6v11.066a8.028 8.028 0 0 0 .7 3.285c1.468 3.306 5.083 5.65 9.3 5.65 4.84 0 8.89-3.09 9.806-7.178a8.235 8.235 0 0 0 .18-1.298C25.997 17.373 26 6 26 6l-1.378.313Zm-.89 2.62v4.075c-1.1-.94-2.603-1.855-4.52-2.75a77.648 77.648 0 0 1 4.52-1.325ZM16 23.667c-4.264 0-7.732-2.962-7.732-6.601 0-.793.763-2.91 7.732-5.657 6.968 2.746 7.732 4.864 7.732 5.657a5.676 5.676 0 0 1-.244 1.648c-.86 2.845-3.891 4.953-7.488 4.953ZM8.268 8.933c1.087.283 2.717.734 4.52 1.325-1.917.895-3.42 1.81-4.52 2.75V8.933Z',
    }),
  );
});
meowSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var meow = {
  category: 'brand',
  colorable: false,
  name: 'meow',
  svg: meowSvg,
};
